var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a',{on:{"click":_vm.register}},[(_vm.webauthnLoading)?_c('a-icon',{attrs:{"type":"loading"}}):(_vm.registered())?_c('a-icon',{staticStyle:{"color":"green"},attrs:{"type":"check"}}):_c('a-icon-fingerprint'),_vm._v(" "+_vm._s(_vm.$t('_.device_auth'))+" ")],1)
}
var staticRenderFns = []

export { render, staticRenderFns }